const WS_URL = "wss://web.fcjznkj.com/go/websocket";
// const WS_URL = "ws://127.0.0.1:3000/go/websocket";

export {
    WS_URL,
}